import { render, staticRenderFns } from "./PillSelectorInput.vue?vue&type=template&id=1513d30c&scoped=true"
import script from "./PillSelectorInput.vue?vue&type=script&lang=js"
export * from "./PillSelectorInput.vue?vue&type=script&lang=js"
import style0 from "./PillSelectorInput.vue?vue&type=style&index=0&id=1513d30c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513d30c",
  null
  
)

export default component.exports